import { useState } from "react";
import { api } from "@/lib/api";
import { Check } from "lucide-react";

export function FooterNewsletter() {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim() || !email.includes("@")) { setError("Introduce un correo válido."); return; }
    if (!consent) { setError("Debes marcar la casilla para aceptar recibir información."); return; }
    setStatus("loading");
    try {
      await api.post("/newsletter/subscribe", { email: email.trim(), consent });
      setStatus("done");
    } catch (err) {
      setStatus("error");
      setError(err?.response?.data?.detail || "No se pudo completar la suscripción.");
    }
  };

  return (
    <div className="relative" data-testid="footer-newsletter">
      <div className="absolute -inset-1 translate-y-2 rounded-[1.6rem] bg-gradient-to-r from-[#2A00D9] via-[#6a5bb0] to-[#B4D844] blur-lg opacity-70" aria-hidden />
      <div className="relative bg-white text-[#1A1A1A] rounded-3xl p-6 md:p-7">
      <p className="eyebrow mb-1.5">La comunidad</p>
      <h2 className="display text-2xl md:text-3xl mb-3">Newsletter</h2>
      {status === "done" ? (
        <div className="flex items-center gap-3 py-3" data-testid="footer-newsletter-success">
          <div className="h-9 w-9 rounded-full bg-[#2A00D9] text-white flex items-center justify-center shrink-0"><Check size={18} /></div>
          <p className="display text-base">Ya formas parte de la comunidad de La Estrofa.</p>
        </div>
      ) : (
        <>
          <p className="text-sm text-[#1A1A1A]/80 max-w-md mb-5 leading-relaxed">
            Suscríbete para no perderte lanzamientos, entrevistas y la agenda de Madrid.
          </p>
          <form onSubmit={submit}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              className="w-full bg-transparent border-b-2 border-[#1A1A1A]/40 pb-2 text-base placeholder:text-[#1A1A1A]/45 focus:outline-none focus:border-[#2A00D9] transition-colors mb-4"
              data-testid="footer-newsletter-email"
            />
            <label className="flex items-start gap-2.5 cursor-pointer mb-5" data-testid="footer-newsletter-consent-label">
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
                className="mt-0.5 h-4 w-4 accent-[#2A00D9] shrink-0"
                data-testid="footer-newsletter-consent"
              />
              <span className="text-[11px] text-[#1A1A1A]/75 leading-relaxed">
                Acepto recibir información de La Estrofa por correo electrónico. Puedo darme de baja cuando quiera.
              </span>
            </label>
            {error && <p className="text-xs font-semibold text-[#8a0000] mb-3" data-testid="footer-newsletter-error">{error}</p>}
            <button
              type="submit"
              disabled={status === "loading"}
              className="btn-cobalt w-full justify-center !py-3 text-sm disabled:opacity-60"
              data-testid="footer-newsletter-submit"
            >
              {status === "loading" ? "Suscribiendo..." : "Suscribirme"}
            </button>
          </form>
        </>
      )}
      </div>
    </div>
  );
}
